<template>
    <div class="wrapper-card">
        <div class="sidenav-wrapper" v-if="width > 1000">
            <SideNav
                :authedUser.sync="authedUser"
                :artistInfo.sync="artistInfo"
                :userInfo.sync="userInfo"
            />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :mode="mode"
                :eventId="eventId"
                :eventDate.sync="eventDate"
                :userId="parseInt(userId)"
            />
            <div class="bottom-line-up"></div>
            <p class="wrap-up-title">Time to Wrap Up</p>
            <PayoutSummary
                :counterOfferData="counterOfferData"
                :bookingId.sync="bookingId"
                :mode="mode"
                :artists.sync="artists"
                :artist-id="artistId"
                :eventId="eventId"
                :eventDate.sync="eventDate"
                :venueFeedbackData.sync="venueFeedbackData"
            />
            <div v-if="venueFeedbackData">
                <VenueFeedbackCard
                    :venueFeedback="venueFeedbackData"
                    :mode="mode"
                    :eventId="eventId"
                    :bookingId="bookingId"
                    :payout="payout"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import PayoutSummary from '../../booking-part/wrap-up-booking/PayoutSummary.vue'
    import VenueFeedbackCard from '../wrap-up-step/VenueFeedbackCard.vue'
    import EventManageHeader from '../../booking-part/EventManageHeader.vue'
    import SideNav from '@/components/parts/SideNav'
    import checkScreen from '@/mixins/check-screen'
    import axios from 'axios'
    import { notification } from '../../../../helpers/notification'

    export default {
        name: 'ArtistWrapUpStep',
        mixins: [checkScreen],
        props: {
            artists: {
                type: Array
            },
            artistId: {
                type: Number
            },
            bookingId: {
                type: Number
            },
            userId: {
                type: Number
            },
            counterOfferData: {
                type: Object
            },
            venueFeedbackData: {
                type: Object
            }
        },
        components: {
            SideNav,
            EventManageHeader,
            PayoutSummary,
            VenueFeedbackCard
        },
        data() {
            return {
                eventId: null,
                eventDate: null,
                mode: 'artistEvent',
                authedUser: false,
                artistInfo: {},
                userInfo: {},
                payout: {}
            }
        },
        async created() {
            this.eventId = localStorage.getItem('eventId')
            this.payout = await this.fetchPayoutArtist()
        },
        methods: {
            async fetchPayoutArtist() {
                try {
                    const response = await axios.get(
                        `/api/booking-manager/artist/${this.eventId}/payout/${this.artistId}`
                    )
                    return response.data.data
                } catch (e) {
                    notification('error', e)
                }
            }
        },
        mounted() {
            this.eventDate = localStorage.getItem('eventDate')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .content-wrapper {
        flex: 0 1 90%;
    }
    .bottom-line-up {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 100%;
        margin-top: 25px;
    }
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
    }
    .wrapper-card {
        display: flex;
        background: #000;
        align-items: flex-start;
        padding: 50px;
        gap: 58px;
        overflow-x: scroll;
    }
    .wrapper-card {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .wrapper-card::-webkit-scrollbar {
        display: none;
    }
    .wrap-up-title {
        color: #d188bf;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        margin-bottom: 25px;
        margin-top: 60px;
    }
    @media (max-width: 600px) {
        .content-wrapper {
            max-width: 100%;
        }
        .wrapper-card {
            padding: 16px;
        }
    }
</style>
